import { Badge } from "@/components/ui/badge";
import { Library } from "lucide-react";
import { SEVERITY_COLORS } from "./IncidentRow";

export function SampleLibrary({ samples, seeding, onSeed }) {
  return (
    <div className="cre-surface rounded-sm">
      <div className="p-5 border-b border-white/10 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Library className="h-4 w-4 text-emerald-300" strokeWidth={1.5} />
          <h2 className="font-heading text-lg font-bold tracking-tight">
            Sample library
          </h2>
        </div>
      </div>
      <div className="p-3 space-y-2">
        {samples.map((s) => (
          <button
            key={s.key}
            data-testid={`sample-${s.key}`}
            onClick={() => onSeed(s.key)}
            disabled={seeding === s.key}
            className="w-full text-left rounded-sm border border-white/10 p-3 hover:border-white/25 hover:bg-white/[0.02] transition-all disabled:opacity-50"
          >
            <div className="flex items-center gap-2">
              <Badge
                variant="outline"
                className={`rounded-sm font-mono text-[10px] ${SEVERITY_COLORS[s.severity] || ""}`}
              >
                {s.severity}
              </Badge>
              <span className="text-sm text-zinc-100 truncate">{s.title}</span>
            </div>
            <div className="mt-1 text-[11px] font-mono text-zinc-500 truncate">
              {s.affected_system}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
